import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { redirectGssUrl } from './header-guest-heading';
export var HeaderGuestHeadingActions = function (_a) {
    var buttons = _a.buttons, gssSigninRedirectParam = _a.gssSigninRedirectParam, context = _a.context;
    return (React.createElement("div", { className: "actions" }, buttons && buttons.map(function (button) {
        var Button = ClickTracker(button.type);
        return (React.createElement(Button, { key: button.linkName, isFullWidth: true, href: redirectGssUrl(button.url, gssSigninRedirectParam, context, false, button.skipRedirectGss), events: "click", rfrr: button.trackingEvent, linkName: button.id, trackImmediate: true, "data-stid": button.stid }, button.text));
    })));
};
//# sourceMappingURL=header-guest-heading-actions.js.map